import { IDisposable } from '@cgs/wge';
import { VoidFunc0 } from '../func/func_imp';

export class DisposeAction implements IDisposable {
  private readonly _action: VoidFunc0;

  constructor(action: VoidFunc0) {
    this._action = action;
  }

  dispose(): void {
    this._action();
  }
}
